module.exports = __webpack_public_path__ + "img/QT.3afc26f9.png";